import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { Crown, Shuffle, ChevronDown, ChevronUp } from "lucide-react";

export function CaptainPlan({ club, onChanged }) {
  const [open, setOpen] = useState(false);
  const [plan, setPlan] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => api.get(`/weekly-sessions/captain-plan?club=${encodeURIComponent(club)}`)
    .then((r) => setPlan(r.data)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { if (open && !plan) load(); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const assign = async (week, player_id) => {
    try {
      if (player_id) await api.post("/coach/captain", { club, week_number: week, player_id });
      else await api.delete(`/coach/captain?club=${encodeURIComponent(club)}&week=${week}`);
      toast.success(player_id ? `Semana ${week}: Capitão avisado por email` : `Semana ${week} sem Capitão`);
      load(); onChanged?.();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const fill = async () => {
    if (!window.confirm("Preencher em ordem aleatória as semanas sem Capitão? As já escolhidas mantêm-se e cada novo Capitão recebe um email.")) return;
    setBusy(true);
    try {
      const r = await api.post("/weekly-sessions/captain-plan/fill", { club });
      setPlan(r.data);
      toast.success(r.data.filled ? `${r.data.filled} semana(s) preenchida(s)` : "Todas as semanas já têm Capitão");
      onChanged?.();
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };

  return (
    <div className="border-t border-[#222] pt-3" data-testid={`captain-plan-${club}`}>
      <button onClick={() => setOpen(!open)} className="kw-overline text-[10px] inline-flex items-center gap-1 hover:text-white"
        data-testid={`captain-plan-toggle-${club}`}>
        <Crown className="w-3 h-3 text-[#EAB308]" /> Plano de Capitães (todas as semanas)
        {open ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
      </button>
      {open && plan && (
        <div className="mt-3 space-y-2">
          <p className="text-[11px] text-[#737373]">
            Na Sessão 0 cada coopetidor escolhe a semana que quer apresentar: atribui aqui. Depois carrega em
            "Preencher o resto" para sortear as semanas que faltam.
          </p>
          <div className="grid sm:grid-cols-2 gap-2">
            {plan.weeks.map((w) => (
              <div key={w.week} className={`flex items-center gap-2 text-xs ${w.past ? "opacity-40" : ""}`}>
                <span className="w-24 shrink-0 text-[#A3A3A3]">S{w.week}{w.when ? ` · ${w.when}` : ""}</span>
                <select className="kw-input !py-1 text-xs flex-1" value={w.captain_id || ""} disabled={w.past}
                  onChange={(e) => assign(w.week, e.target.value)} data-testid={`captain-plan-week-${club}-${w.week}`}>
                  <option value="">— Sem Capitão —</option>
                  {plan.candidates.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
                </select>
              </div>
            ))}
          </div>
          <button onClick={fill} disabled={busy} className="kw-btn-secondary !py-1.5 text-[10px] inline-flex items-center gap-1.5"
            data-testid={`captain-plan-fill-${club}`}>
            <Shuffle className="w-3.5 h-3.5" /> Preencher o resto (aleatório)
          </button>
        </div>
      )}
    </div>
  );
}
